/** Which app registration signs a person in through their company's SSO (pure, tested with node --test).
 *
 * Company federations live in a separate External ID user flow with its own app (the identity service's
 * SSO_USER_FLOW_ID / DASHBOARD_SSO_CLIENT_ID), never in the dashboard's normal flow, whose sign-in page would list them
 * all. The dashboard signs in through that app only after discovery said SSO: config.js `ssoClientId`, else the
 * client id in discovery's ready-made `login_url` (the identity service knows it). Null: the dashboard's own app. */
export function ssoClientId(configured: string | undefined, loginUrl: string | undefined): string | null {
  if (configured) return configured;
  try {
    return loginUrl ? new URL(loginUrl).searchParams.get("client_id") || null : null;
  } catch {
    return null;
  }
}
